import {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import "../styles/Waiting.scss";
import {BackButton, LanguageSelector} from "../components";
import {useRegisterQueue} from "src/services/waitingQueue/hooks/useRegisterQueue";
import {useLocation, useNavigate} from "react-router-dom";
import {Artist, getArtistFromPath} from "src/utils/artist.utils";
import {path} from "src/router/path";
import {WaitingQueueStatus} from "src/services/waitingQueue/logic/types/waitingQueue.types";
import posterImage from "../assets/images/riize/poster_riize.png";
import rizuko from "../assets/images/riize/character/character_rizuko.png";
import {ARTIST_LAUNCH_DATES} from "src/utils/launchDate.constants";

const WaitingRiize = () => {
  const navigate = useNavigate();
  const {t} = useTranslation("common");
  const {t: tRiize} = useTranslation("riize");

  const location = useLocation();
  const artist = getArtistFromPath(location.pathname) as Artist;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleBack = () => {
    navigate(path.home(artist));
  };

  const handleServiceUnavailable = useCallback(() => {
    navigate(path.error(artist), {replace: true});
  }, [navigate, artist]);

  const {registerQueue} = useRegisterQueue({
    artist,
    onServiceUnavailable: handleServiceUnavailable,
  });

  const handleRegisterQueue = async () => {
    try {
      const response = await registerQueue();
      if (response.status === WaitingQueueStatus.WAITING) {
        navigate(path.waitingQueue(artist), {
          state: {queueInfo: response},
        });
      }
      if (response.status === WaitingQueueStatus.ACTIVE) {
        navigate(path.code(artist));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const now = new Date();
    const currentTime = new Date(
      now.toLocaleString("en-US", {timeZone: "Asia/Seoul"}),
    );

    const targetDate = ARTIST_LAUNCH_DATES.riize;
    if (currentTime >= targetDate) {
      setIsOpen(true);
    }
  }, []);

  return (
    <div className="waiting-container">
      <img src={posterImage} alt="" className="waiting-poster-image" />
      <div className="waiting-character-layer">
        <div className="waiting-character-wrapper">
          <div className="waiting-character-greeting">
            {tRiize("waiting.greeting")}
          </div>
          <div className="waiting-character">
            <img src={rizuko} alt="" className="waiting-character-image" />
          </div>
        </div>
      </div>
      <div className="waiting-header">
        <BackButton artist={artist} onClick={handleBack} />
        <LanguageSelector artist={artist} />
      </div>
      <div className="waiting-spacer" />
      <div className="waiting-bottom-section">
        <button
          className={`start-button ${isOpen ? "" : "coming-soon"} ${artist}`}
          onClick={isOpen ? handleRegisterQueue : () => {}}
        >
          {isOpen
            ? t("waiting.button")
            : t("waiting.buttonComingSoon", {month: "3", day: "30"})}
        </button>
        <p className="code-instruction">{t("waiting.guide")}</p>
      </div>
    </div>
  );
};

export default WaitingRiize;
